/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowPlayerV2 = {
    properties: {
        player: {
            type: 'IdElement',
            isRequired: true,
        },
        notification: {
            type: 'boolean',
            isRequired: true,
        },
        notificationLineup: {
            type: 'boolean',
            isRequired: true,
        },
        notificationGoals: {
            type: 'boolean',
            isRequired: true,
        },
        notificationCards: {
            type: 'boolean',
            isRequired: true,
        },
        notificationChances: {
            type: 'boolean',
            isRequired: true,
        },
        notificationTransfers: {
            type: 'boolean',
            isRequired: true,
        },
        notificationManOfTheMatch: {
            type: 'boolean',
            isRequired: true,
        },
        notificationTeamOfTheWeek: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
